export default __webpack_public_path__ + "dc9b505598e89d1e0a08114b27e24872.svg";